$(document).ready(function(){
  function randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  function get_random (list) {
    return list[Math.floor((Math.random()*list.length))];
  }

  var salesItemsDD = randomIntFromInterval(min_sales_items,max_sales_items);
  $('.sold_product .items-count').text(salesItemsDD);

  var customerViewsDD = randomIntFromInterval(min_customer_views,max_customer_views);
  $('.customer-view-count').text(customerViewsDD);
  $('.sold_product .items-count,.customer-view-count').css("color","#000");

  setInterval(function(){
    min_customer_views = parseInt(customerViewsDD)+10;
    max_customer_views = parseInt(customerViewsDD)-10;

    min_sales_items = parseInt(salesItemsDD)+2;
    max_sales_items = parseInt(salesItemsDD)-1;

    customerViewsDD = randomIntFromInterval(min_customer_views,max_customer_views);
    $('.customer-view-count').text(customerViewsDD);

    salesItemsDD = randomIntFromInterval(min_sales_items,max_sales_items);
    $('.sold_product .items-count').text(salesItemsDD);
  }, 10000);
});